module.exports = __webpack_public_path__ + "static/img/card.0bc7cd5.1721208215485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card.png
// module id = Pzc5
// module chunks = 65